const mapBoxConfig = {
    mapBoxToken: process.env.REACT_APP_MAPBOX_TOKEN
}

export default mapBoxConfig